import { Lock } from 'lucide-react';

// First letter of the first and last name parts — "Sarah Jones" → "SJ".
const initialsOf = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'U';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

/**
 * The FOH header's signed-in identity: an initials circle and a one-tap Lock that returns
 * the terminal to the PIN screen ("done" state). No name spelled out — the initials are
 * enough on a shared terminal, and the full name is one tap away (title, and the account
 * sheet later). No dropdown — locking is a between-tables action, not a buried menu item.
 * The back office keeps its own `UserDropdown` (Bridge / Node links live there).
 */
export const FOHUserChip = ({ user, onLock }) => {
  const name = user?.name || user?.email || 'User';

  const first = String(name).trim().split(/\s+/)[0] || name;

  // Who's on the till, by name (FOH UX review, wave 3): a shared till changes hands every
  // few minutes and "MM" in a circle tells the next server nothing. The lock says "Lock".
  return (
    <div className="flex items-center gap-2" data-testid="foh-user-chip">
      {/* A div, not a span: the FOH layout forces square corners on `span[class*="bg-"]`.
          Square box + 50% radius = a true circle. */}
      <div
        className="flex h-8 w-8 shrink-0 items-center justify-center bg-verlo
                   text-[11px] font-bold tracking-wide text-white select-none"
        style={{ borderRadius: '50%' }}
        title={name}
        data-testid="foh-user-initials"
      >
        {initialsOf(name)}
      </div>
      <span className="hidden lg:inline max-w-[10rem] truncate text-[13px] font-semibold text-ink" title={name} data-testid="foh-user-name">
        {first}
      </span>
      <button
        type="button"
        onClick={onLock}
        aria-label="Lock terminal"
        title="Lock the till"
        className="ml-1 inline-flex h-9 items-center gap-1.5 border border-hairline px-3 text-[13px] font-medium text-verlo transition-all hover:bg-verlo-tint active:scale-95
                   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-verlo"
        data-testid="foh-lock-btn"
      >
        <Lock size={15} />
        Lock
      </button>
    </div>
  );
};

export default FOHUserChip;
